import { DropdownOption } from '../../components/Dropdown'

export const keyOfOptions: DropdownOption[] = [
  { label: 'A', value: 'A' },
  { label: 'A#', value: 'A#' },
  { label: 'Bb', value: 'Bb' },
  { label: 'B', value: 'B' },
  { label: 'C', value: 'C' },
  { label: 'C#', value: 'C#' },
  { label: 'Db', value: 'Db' },
  { label: 'D', value: 'D' },
  { label: 'D#', value: 'D#' },
  { label: 'Eb', value: 'Eb' },
  { label: 'E', value: 'E' },
  { label: 'F', value: 'F' },
  { label: 'F#', value: 'F#' },
  { label: 'Gb', value: 'Gb' },
  { label: 'G', value: 'G' },
  { label: 'G#', value: 'G#' },
  { label: 'Ab', value: 'Ab' },
  { label: 'Numbers', value: 'numbers' }
]

export const capoOptions: DropdownOption[] = [
  { label: 'No Capo', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' }
]
